import AnimatedProgressArc from '@/components/Animated/AnimatedProgressArc'
import RightChevronIcon from '@/CustomIcons/RightChervron'
import SendIcon from '@/CustomIcons/SendIcon'
import { Button } from '@/UIComponents2/Button'
import { useUserContext } from '@/UserContext'
import moment from 'moment'
import { useEffect, useState } from 'react'

export default function BoostsCard(): JSX.Element {
    const [userState] = useUserContext()
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const currentRechargeDate = moment(
            userState.profile?.boostNextRechargeDate ?? moment(new Date()).startOf('day').add(1, 'day')
        )
        const priorRechargeDate = moment(currentRechargeDate).subtract(1, 'month')
        const daysBetweenCycle = currentRechargeDate.diff(priorRechargeDate, 'days')
        const daysSinceLastRecharge = moment(new Date()).diff(priorRechargeDate, 'days')
        setProgress(daysSinceLastRecharge / daysBetweenCycle)
    }, [userState.profile?.boostNextRechargeDate])

    return (
        <div className="w-full h-full flex-col bg-[url('/images/sparkle.webp')] bg-no-repeat bg-[rgba(21,21,21,0.85)] border-muse-toplit shadow-glow rounded-[28px]">
            <div className="w-full px-[30px] flex justify-between items-center pt-[30px]">
                <span>Boosts</span>
                <div className="flex items-center gap-[8px]">
                    <span className="opacity-50">Details</span>
                    <Button>
                        <RightChevronIcon />
                    </Button>
                </div>
            </div>
            <div className="flex flex-col w-full items-center pt-[20px]">
                <span className="text-[52px]">{String(userState.profile?.boostsRemaining ?? 0).padStart(2, '0')}</span>
                <span className="opacity-60">/ {userState.profile?.boostsMax ?? 0} per month</span>
            </div>
            <div>
                <AnimatedProgressArc
                    targetProgress={progress}
                    targetText={moment(
                        userState.profile?.boostNextRechargeDate ?? moment(new Date()).startOf('day').add(1, 'day')
                    ).format('MM/DD')}
                    subArcContent={
                        <div className="w-full px-[8px] pt-[65px] flex flex-col items-center gap-[18px]">
                            <p className="w-[75%] font-light text-center">
                                Boosts give you access to <strong>Pro Features</strong>, invite your friends to get
                                them.
                            </p>
                            {/* What to do with button? */}
                            <Button variant="secondary" className="relative w-full p-[8px]">
                                Invite Friends
                                <SendIcon className="absolute right-4 -rotate-45" outlineOnly />
                            </Button>
                        </div>
                    }
                />
            </div>
        </div>
    )
}
